import {
  IconUser,
  IconPhone,
  IconSchool,
  IconCreditCard,
  IconChecklist,
  IconCertificate2,
  IconBooks,
  IconInfoSquareRounded,
} from '@tabler/icons-react';
import {
  PersonalDataForm,
  EducationalProgramForm,
  ExtraDataForm,
  StudiesDataForm,
  ContactDataForm,
  FacturacionDataForm,
  HomologationForm,
  ConfirmationForm,
} from '../pages';
import { stepIds } from '../enums/fieldsDataConfig';

export const getStepsConfig = (queryParams, typeConfig) => [
  {
    isEnable: true,
    id: stepIds.PROGRAMA,
    title: `Selección de ${typeConfig[queryParams.t]?.shortDescription || 'Programa'}`,
    description: 'Completa los datos',
    form: EducationalProgramForm,
    icon: <IconSchool style={{ width: 18, height: 18 }} />,
  },
  {
    isEnable: true,
    id: stepIds.PERSONA,
    title: 'Datos Personales',
    description: 'Completa tu información personal',
    form: PersonalDataForm,
    icon: <IconUser style={{ width: 18, height: 18 }} />,
  },
  {
    isEnable: true,
    id: stepIds.CONTACTO,
    title: 'Datos de Contacto',
    description: 'Proporciona tus datos de contacto',
    form: ContactDataForm,
    icon: <IconPhone style={{ width: 18, height: 18 }} />,
  },
  {
    // Homologacion (preinforme) existe solo para la universidad: en colegios y Club el paso no se
    // muestra y NBAPI ignora solicitaPreinforme (decision de Matias 22/09/2026, T-2026-110).
    isEnable: queryParams.t !== 'e' && queryParams.t !== 'm' && queryParams.e === 'UAI',
    id: stepIds.HOMOLOGACION,
    title: 'Detalles Académicos',
    description: 'Información para homologación y declaraciones',
    form: HomologationForm,
    icon: <IconCertificate2 style={{ width: 18, height: 18 }} />,
  },
  {
    isEnable: queryParams.t !== 'e' && queryParams.t !== 'm',
    id: stepIds.ESTUDIOS,
    title: 'Estudios',
    description: 'Información de los estudios previos realizados',
    form: StudiesDataForm,
    icon: <IconBooks style={{ width: 18, height: 18 }} />,
  },
  {
    isEnable: true,
    id: stepIds.DATOS_ADICIONALES,
    title: 'Datos Adicionales',
    description: 'Incluye información adicional',
    form: ExtraDataForm,
    icon: <IconInfoSquareRounded style={{ width: 18, height: 18 }} />,
  },
  {
    isEnable: true,
    id: stepIds.FACTURACION,
    title: 'Facturación',
    description: 'Confirma detalles de pago',
    form: FacturacionDataForm,
    icon: <IconCreditCard style={{ width: 18, height: 18 }} />,
  },
  {
    isEnable: true,
    id: stepIds.CONFIRMACION,
    title: 'Confirmación',
    description: 'Revisa y finaliza tu preinscripción',
    form: ConfirmationForm,
    icon: <IconChecklist style={{ width: 18, height: 18 }} />,
  },
];